"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AdditionalInformationItem_1 = __importStar(require("@features/ItemCommon/components/common/AdditionalInformationItem"));
var util_1 = require("@features/ItemCommon/components/fields/ItemContent/util");
var react_i18next_1 = require("react-i18next");
var implioFilters_1 = require("@/react-app/features/Search/FilterBar/FilterSideBar/implioFilters");
function JobUserPhoneList(_a) {
    var remoteIdDomain = _a.remoteIdDomain, phoneNumbers = _a.phoneNumbers, angularJsDependencies = _a.angularJsDependencies, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null, phoneNumbers &&
        phoneNumbers.map(function (phone, index) {
            return (react_1.default.createElement(AdditionalInformationItem_1.default, { key: index, cyName: "job-user-phoneNumber", titleTranslationKey: "SEARCH.ITEM.SEARCH_PHONE_NUMBER_TOOLTIP_REACT", label: index === 0 ? t('ITEM.PHONE') : '', value: phone, sanitizedValue: (0, util_1.stripValueFromHighlight)(phone), angularJsDependencies: angularJsDependencies, renderTag: "link", searchText: implioFilters_1.filterKey.userPhone, customValuesContainerClassName: "justify-start", domain: remoteIdDomain, withQuickAddToList: true, classOverride: AdditionalInformationItem_1.defaultClassOverrideForItemDetail, automationListsPermission: automationListsPermission }));
        })));
}
exports.default = JobUserPhoneList;
